export const widgetId = 'document-viewer';
